import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import { Stack } from '../Layout';
const parseUrlQueryParams = (url) => {
    try {
        const urlObj = new URL(url);
        const params = {
            width: urlObj.searchParams.get('width') || undefined,
            height: urlObj.searchParams.get('height') || undefined,
            align: urlObj.searchParams.get('align') || undefined
        };
        // delete the params from the url
        urlObj.searchParams.delete('width');
        urlObj.searchParams.delete('height');
        urlObj.searchParams.delete('align');
        const cleanUrl = urlObj.toString();
        return { cleanUrl, params };
    }
    catch {
        // If URL parsing fails, return original URL with no params
        return { cleanUrl: url, params: {} };
    }
};
export const ImageElement = forwardRef(({ className: _className, nodeProps, ...props }, ref) => {
    const { children, element } = props;
    const { url, alt } = element;
    const { cleanUrl, params } = useMemo(() => {
        return parseUrlQueryParams(url);
    }, [url]);
    const imageStyle = useMemo(() => {
        const style = {};
        if (params.width) {
            style.width = params.width;
        }
        if (params.height) {
            style.height = params.height;
        }
        return style;
    }, [params]);
    return (_jsxs(Stack, { ref: ref, contentEditable: false, alignY: params.align, children: [_jsx("img", { ...nodeProps, alt: alt, src: cleanUrl, style: imageStyle }), children] }));
});
